import React, { useEffect, useState } from 'react';
import './NavbarButton.css';
import InputSerach from '../InputSerach/InputSearchs';
import Favoritos from '../Favoritos/Favoritos';
import baseURL from '../url';
import { Link as Anchor } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

export default function NavbarButton() {
    const [tienda, setTienda] = useState({});
    const [openSocials, setOpenSocials] = useState(false);

    useEffect(() => {
        cargarTienda();
    }, []);

    const cargarTienda = () => {
        fetch(`${baseURL}/tiendaGet.php`)
            .then(response => response.json())
            .then(data => {
                setTienda(data.tienda?.[0] || {});
            })
            .catch(error => console.error('Error al cargar datos:', error));
    };

    const abrirMapa = () => {
        const dir = encodeURIComponent(tienda.direccion);
        window.open(`https://www.google.com/maps/search/?api=1&query=${dir}`, '_blank');
    };

    return (
        <div className='NavbarButtonContent'>
            <div className={`Modalsocials ${openSocials ? 'active' : ''}`}>
                <Anchor to={`mailto:${tienda.email}`} target='_blank' className='socialLink'>
                    <FontAwesomeIcon icon={faEnvelope} />
                    <span>Email</span>
                </Anchor>
                <Anchor to={`https://wa.me/${tienda.telefono}`} target='_blank' className='socialLink socialLink--whatsapp'>
                    <FontAwesomeIcon icon={faWhatsapp} />
                    <span>WhatsApp</span>
                </Anchor>
                <button onClick={abrirMapa} className='socialLink socialLink--map'>
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                    <span>Dirección</span>
                </button>
            </div>

            {openSocials && <div className='Modalsocials__overlay' onClick={() => setOpenSocials(false)} />}

            <div className='NavbarButton'>
                <InputSerach />

                <button
                    className={`plusButton ${openSocials ? 'open' : ''}`}
                    onClick={() => setOpenSocials(!openSocials)}
                >
                    <span className='plusButton__line plusButton__line--h' />
                    <span className='plusButton__line plusButton__line--v' />
                </button>

                <Favoritos />
            </div>
        </div>
    );
}